module.exports = __webpack_public_path__ + "media/Loops Drums.2c805278.wav";